/**
 * Die App-Seite des CRM: Service Worker, "installiert oder im Browser",
 * Aktualisierungshinweis, Badge am Icon.
 *
 * Alles hier ist optional: Wo der Browser etwas nicht kann (alter Safari,
 * Firefox ohne Push), passiert nichts - die Anwendung laeuft wie bisher.
 */
import { toast } from "sonner";

/** Laeuft die Seite als installierte App (Home-Bildschirm) statt im Browser-Tab? */
export function istInstalliert() {
  try {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch {
    return false;
  }
}

/** iPhone oder iPad - dort geht "Zum Home-Bildschirm" nur ueber das Teilen-Menue in Safari. */
export function istApple() {
  const ua = navigator.userAgent || "";
  // iPadOS meldet sich als Mac; der Touch-Punkt verraet es.
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
}

let registrierung = null;

/** Meldet den Service Worker an. Einmal beim Start, danach kuemmert sich der Browser. */
export async function serviceWorkerStarten() {
  if (!("serviceWorker" in navigator)) return null;
  // Im Entwicklungsserver (craco start) waere ein Service Worker nur im Weg:
  // er wuerde die alte Fassung festhalten, waehrend man gerade aendert.
  if (process.env.NODE_ENV !== "production") return null;
  try {
    registrierung = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    // Schon eine Seite unter Kontrolle? Dann ist jeder Wechsel des aktiven
    // Workers ein Deploy - und die Seite sollte neu laden.
    let hatteController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hatteController) { hatteController = true; return; }
      toast("Neue Version des CRM ist da.", {
        description: "Einmal neu laden, dann ist alles aktuell.",
        duration: 15000,
        action: { label: "Neu laden", onClick: () => window.location.reload() },
      });
    });
    navigator.serviceWorker.addEventListener("message", (e) => {
      // Eine Meldung wurde angetippt, waehrend die App offen war, und der
      // Worker konnte nicht selbst navigieren.
      if (e.data?.typ === "oeffne" && e.data.url) {
        const u = new URL(e.data.url, window.location.origin);
        window.location.assign(u.pathname + u.search + u.hash);
      }
    });
    return registrierung;
  } catch {
    return null;
  }
}

export async function serviceWorkerBereit() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return registrierung || (await navigator.serviceWorker.ready);
  } catch {
    return null;
  }
}

/**
 * Die Zahl am App-Icon: was auf mich wartet. Bei null verschwindet sie.
 * iOS zeigt sie nur bei installierter App mit erteilter Meldungs-Erlaubnis;
 * ueberall sonst passiert schlicht nichts.
 */
export async function badgeSetzen(anzahl) {
  try {
    if (!("setAppBadge" in navigator)) return;
    if (anzahl > 0) await navigator.setAppBadge(anzahl);
    else await navigator.clearAppBadge();
  } catch {
    /* nicht erlaubt oder nicht installiert - egal */
  }
}
